import React from 'react'

/* 
  asOverlay: <boolean>, whether to display as a whole page overlay
  additionalInfo: <string>, additional info to be displayed below the indicator
  size: <string>, Adds the size as string. Currently only sm is defined, see common.scss,
  initialDelay: <integer> initial delay in milliseconds before rendering anything to avoid flashin on fast loads
*/
const LoadingIndicator = ({asOverlay, additionalInfo='', size = '', initialDelay = 0, overlayClasses = ''}) => {

  const [visible, setVisible] = React.useState(initialDelay == 0);

  React.useEffect(() => {
    let timeout = setTimeout(() => {setVisible(true)}, initialDelay);
    return () => {clearTimeout(timeout)}
  }, [])

  // if (!visible) return null;

  const loadingIndicator = (<>
    <div className={`loading-indicator ${size}`}>
      <div className="loading-box1 loading-box"></div>
      <div className="loading-box2 loading-box"></div>
      <div className="loading-box3 loading-box"></div>
      <div className="loading-box4 loading-box"></div>
      <div className="loading-box5 loading-box"></div>
      <div className="loading-box6 loading-box"></div>
      <div className="loading-box7 loading-box"></div>
      <div className="loading-box8 loading-box"></div>
      <div className="loading-box9 loading-box"></div>
      <div className="loading-box10 loading-box"></div>
      <div className="loading-box11 loading-box"></div>
      <div className="loading-box12 loading-box"></div>
    </div>
    <div className="loading-indicator-additional-info">{additionalInfo}</div>
  </>);

  if (asOverlay) {
    return <div className={`loading-indicator-overlay ${overlayClasses}`}>
      {loadingIndicator}
    </div>
  }

  return loadingIndicator
}
export default LoadingIndicator;